import dayjs from "dayjs";

import Sentry from "@similarweb/sentry-logger";

import { TEAMS } from "app/constants/teamName";
import { DefaultFetchService } from "app/services/fetchService";

const isValidDateString = (dateString: string): boolean => {
    if (!dateString || typeof dateString !== "string") {
        return false;
    }
    const parsed = dayjs(dateString);
    return parsed.isValid();
};

export const postUserDiscountDate = async (timeDiscountEnds: string) => {
    if (!isValidDateString(timeDiscountEnds)) {
        Sentry.errorTracker({
            e: new Error("Invalid date string format"),
            message: "Error posting postUserDiscountDate - invalid date format",
            level: "error",
            params: {
                tags: { team: TEAMS.GROWTH },
            },
        });
        return false;
    }

    try {
        const fetchService = DefaultFetchService.getInstance();
        await fetchService.post("/api/userdata/custom-data/update", {
            DiscountEndDate: timeDiscountEnds,
        });
        return true;
    } catch (error) {
        Sentry.errorTracker({
            e: error,
            message: "Error posting postUserDiscountDate",
            level: "error",
            params: {
                tags: { team: TEAMS.GROWTH },
            },
        });
        return false;
    }
};
